import { Divider } from '@nextui-org/react';
import React from 'react';

import {
  DiscordIcon,
  FooterLogoIcon,
  IconBlogFooter,
  MediumIcon,
  TelegramIcon,
  TwitterIcon,
  YoutubeIcon,
} from '@/assets';
import { MyLink } from '@/components';

export const introduction = [
  {
    title: 'About',
    items: ['Introduction', 'Careers',],
    links: [
      'https://docs.airight.io/whitepaper/introduction',
      'https://oraichain.notion.site/Recruitment-News-September-2023-b14d9467f9604b3d9cf9a3282730cec5',
    ],
  },
  {
    title: 'Ecosystem',
    items: ['Mainnet', 'Oraichain VRF 2.0', 'EUENO', 'Other dApps'],
    links: [
      'https://orai.io',
      'https://docs.orai.io/vrf/introduction',
      'https://eueno.io',
      'https://medium.com/m/global-identity-2?redirectUrl=https%3A%2F%2Fblog.orai.io%2Foraichain-roadmap-for-2022-3a6fca7ace86',
    ],
  },
  {
    title: 'Resources',
    items: ['Media kit', 'Patent', 'Docs', 'Contact', 'Support'],
    links: [
      'https://airight.io/media-kit',
      'https://patentscope.wipo.int/search/en/detail.jsf?docId=WO2022200834&_cid=P12-LBD67M-45114-1',
      'https://docs.airight.io/whitepaper/introduction',
      'mailto:contact@orai.io',
      'https://t.me/airight_io',
    ],
  },
];

const Footer: React.FC = ({}) => {
  const RenderLink = (item: string, href: string, key: number) => (
    <MyLink
      target={href === '/faq' ? '_self' : '_blank'}
      className="mb-2 text-16 font-normal"
      key={key}
      href={href || ''}
    >
      {item}
    </MyLink>
  );

  return (
    <footer className="bg-gray-50 p-13 lg:p-5">
      <div className="flex justify-between lg:flex-col">
        <div className="mr-3 flex w-1/3 flex-col lg:m-0 lg:w-full lg:text-center">
          <div className="flex items-center gap-2">
            <FooterLogoIcon className="lg:self-center" />
            <span>aiRight</span>
          </div>
          <p className="py-7 text-16 font-normal lg:py-4">
            aiRight is the world-first Web UI platform empowering anyone to create with AI models &
            a massive data library. Safeguard your copyright on-chain - all without coding. Free
            your creativity!
          </p>
          <p className="text-16 font-normal text-gray-500">Powered by Oraichain Labs</p>
        </div>
        <Divider className="my-10 hidden text-gray-200 lg:block" />
        <div className="ml-3 flex w-2/3 flex-1 justify-evenly lg:m-0 lg:w-full sxm:flex-wrap sxm:justify-start">
          {introduction.map((info, index_P) => (
            <div
              aria-expanded={index_P < 2}
              aria-checked={index_P > 0 && index_P < introduction.length - 1}
              key={index_P}
              className="flex flex-col aria-checked:mx-3 sm:w-1/2 sm:justify-start aria-expanded:sm:!mb-3 sxm:!mx-0"
            >
              <p className="pb-5 text-20 font-semibold">{info.title}</p>
              {info.items.map((item, indexC) => RenderLink(item, info.links[indexC] || '', indexC))}
            </div>
          ))}
        </div>
      </div>
      <Divider className="my-9 hidden text-gray-200 lg:block" />
      <div className="flex flex-col items-center pt-[50px] lg:p-0">
        <div className="flex gap-6 pb-7">
          <MyLink href="https://blog.airight.io/">
            <IconBlogFooter />
          </MyLink>
          <MyLink href="https://medium.com/airight">
            <MediumIcon />
          </MyLink>
          <MyLink href="https://t.me/airight_io">
            <TelegramIcon />
          </MyLink>
          <MyLink href="https://twitter.com/aiRight_io">
            <TwitterIcon />
          </MyLink>
          <MyLink href="https://discord.gg/KcvgeUsjwt">
            <DiscordIcon />
          </MyLink>
          <MyLink href="https://www.youtube.com/@airight3541">
            <YoutubeIcon />
          </MyLink>
        </div>
        <p className="text-16 font-normal text-gray-500">
          ©2020 - 2023 Oraichain Labs. All rights reserved. Privacy Policy
        </p>
      </div>
    </footer>
  );
};

export default Footer;
